import createIcon from '../../createIcon';

/**
 * @component @name RoundaboutLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMDggOEMxMC41NiA1LjE2IDEzLjAyIDMgMTYgM0MxOS4zMSAzIDIyIDUuNjkgMjIgOUMyMiAxMS45NyAxOS44NCAxNC40NCAxNyAxNC45MlYyMUgxNVYxNC45MUMxNSAxMy45MyAxNS43MSAxMy4xMSAxNi42NyAxMi45NEMxOC41NiAxMi42MyAyMCAxMC45OCAyMCA5QzIwIDYuNzkgMTguMjEgNSAxNiA1QzE0LjAyIDUgMTIuMzcgNi40NCAxMi4wNiA4LjMzQzExLjg5IDkuMjkgMTEuMDcgMTAgMTAuMDkgMTBINS44M0w3LjQyIDExLjU5TDYgMTNMMiA5TDYgNUw3LjQxIDYuNDFMNS44MyA4SDEwLjA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RoundaboutLeft = createIcon('RoundaboutLeft', [
  [
    'path',
    {
      d: 'M10.08 8C10.56 5.16 13.02 3 16 3C19.31 3 22 5.69 22 9C22 11.97 19.84 14.44 17 14.92V21H15V14.91C15 13.93 15.71 13.11 16.67 12.94C18.56 12.63 20 10.98 20 9C20 6.79 18.21 5 16 5C14.02 5 12.37 6.44 12.06 8.33C11.89 9.29 11.07 10 10.09 10H5.83L7.42 11.59L6 13L2 9L6 5L7.41 6.41L5.83 8H10.08Z',
      key: '1lrrrb',
    },
  ],
]);

export default RoundaboutLeft;
